import { ThemeColors } from '@lyrahealth-inc/shared-app-logic'

import { getButtonStyles } from './buttonStyles'

export const getAuroraButtonStyles = (tokenColors: ThemeColors) => {
  const defaultButtonStyles = getButtonStyles(tokenColors)

  return {
    ...defaultButtonStyles,
    secondary: {
      ...defaultButtonStyles.secondary,
      default: {
        ...defaultButtonStyles.secondary.default,
        base: {
          color: tokenColors.secondaryButtonTextActive,
          border: 'none',
          backgroundColor: tokenColors.secondaryButtonBackgroundDefault,
          minWidth: 100,
        },
      },
    },
  }
}
